import axios from "axios";
import {
  geoServerAuthHeaders,
  isProtectedWorkspace,
  workspaceFromUrl,
} from "./geoServerAuth";

// export const geoServerBaseUrl = process.env.REACT_APP_GEOSERVER_BASE_URL;
// export const geoServerBaseUrl = 'https://geoserver.isitics.com/geoserver';
// export const geoServerBaseUrl = "https://dev.geoserver.isitics.com/geoserver";
export const geoServerBaseUrl = "https://geoserver-atlas.isitics.com/geoserver";

export const geoServerDefaultParams = {
  service: "WFS",
  version: "1.0.0",
  request: "GetFeature",
  outputFormat: "application/json",
};

export const geoServerPopupDefaultParams = {
  SERVICE: "WMS",
  VERSION: "1.1.1",
  REQUEST: "GetFeatureInfo",
  FORMAT: "text/html",
  TRANSPARENT: "true",
  // QUERY_LAYERS: 'Facepe_2:municipios_pib_apl',
  STYLES: "",
  // LAYERS: 'Facepe_2:municipios_pib_apl',
  exceptions: "application/vnd.ogc.se_inimage",
  INFO_FORMAT: "text/html",
  FEATURE_COUNT: "50",
  X: "50",
  Y: "50",
  SRS: "EPSG:4674",
  WIDTH: "101",
  HEIGHT: "101",
  // BBOX: '-35.212554931640625,-8.4100341796875,-34.935150146484375,-8.13262939453125',
};

export const geoServerLegendDefaultParams = {
  service: "wms",
  version: "1.0.0",
  request: "GetLegendGraphic",
  format: "image/png",
  width: 20,
  height: 20,
};

export const geoServerLegendJsonParams = {
  service: "wms",
  version: "1.0.0",
  request: "GetLegendGraphic",
  format: "application/json",
};

export const geoServer = axios.create({
  baseURL: geoServerBaseUrl,
});

/**
 * Anexa a credencial de leitura quando a requisição toca um workspace protegido
 * (legenda, colormap, GetFeatureInfo). O workspace aparece ora no caminho
 * (`/geoserver/<ws>/wms`), ora qualificando a camada (`<ws>:<layer>`).
 */
geoServer.interceptors.request.use((config) => {
  const params = (config.params ?? {}) as Record<string, unknown>;
  const qualified = [
    params.layers,
    params.LAYERS,
    params.query_layers,
    params.QUERY_LAYERS,
    params.typeNames,
    params.typeName,
    params.layer,
  ]
    .filter((value): value is string => typeof value === "string")
    .map((value) => value.split(":")[0]);

  const candidates = [workspaceFromUrl(config.url), ...qualified];
  const workspace = candidates.find((candidate) =>
    isProtectedWorkspace(candidate)
  );

  const authHeaders = geoServerAuthHeaders(workspace);
  if (authHeaders.Authorization) {
    config.headers.set("Authorization", authHeaders.Authorization);
  }
  return config;
});

// add dinamically the city. Eg: cql_filter: `nm_mun='${cityResp}'`,
export const geoServerGetCityCoordinatesParams = {
  service: "wfs",
  version: "2.0.0",
  request: "GetFeature",
  typeNames: "pepe-atlas:municipios_pe",
  outputFormat: "application/json",
};
